import { render, staticRenderFns } from "./delete-inventory.vue?vue&type=template&id=4142959a&"
import script from "./delete-inventory.vue?vue&type=script&lang=js&"
export * from "./delete-inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports